import { Heading } from '@simplywallst/ui-core/next';
import { usePortfolios } from '@/hooks/portfolio/usePortfolio';
import { useUserAccess } from '@/hooks/useUserAccess';
import { NewManualPortfolio } from './NewManualPortfolio';
import { NewLinkedPortfolio } from './NewLinkedPortfolio';

export const NewPortfolio = () => {
  const { data, isLoading } = usePortfolios();
  const { data: userAccess } = useUserAccess();

  return (
    <section className="grid w-full max-w-screen-xl bg-surface-1 text-solid @container/newPortfolio sm:gap-x4 sm:px-x3 sm:py-x4 lg:rounded-lg">
      <div className="flex flex-wrap items-center justify-between gap-x-x4 gap-y-x2 px-x2 py-x4 sm:p-0">
        <div className="grid gap-x1">
          <Heading size="xLarge">
            {(isLoading && '') ||
              (data?.length && 'Create a new portfolio in minutes') ||
              'Create your first portfolio in minutes'}
          </Heading>
          {['free', null].includes(userAccess.planType) && (
            <div className="max-w-[55ch] text-xs text-softer">
              Free forever for up to 10 holdings.
            </div>
          )}
        </div>
      </div>
      <div className="grid gap-x2 @5xl/newPortfolio:grid-cols-[61.8%_auto] sm:gap-x3">
        <section className="flex flex-col gap-x2 bg-surface-2 py-x3 [--draggable-bg:--s-color-surface-2] sm:gap-x3 sm:rounded-lg">
          <NewLinkedPortfolio />
        </section>
        <section className="bg-surface-2 px-x2 py-x3 sm:rounded-lg sm:p-x3">
          <NewManualPortfolio />
        </section>
      </div>
    </section>
  );
};
